export enum AssetDocumentType {
    CONTRACT_DATA = 0,
    REPORTING = 1,
    CONSUMER_INFORMATION = 2,
}

export enum AssetCategory {
    DEFAULT = 0,
    STARTUP = 1,
    SME = 2,
    REAL_ESTATE = 3,
    SPECIAL = 4,
    STOCK_EMISSION = 5,
}

export enum AssetStatus {
    ACTIVE = 'active',
    UNDER_OBSERVATION = 'under_observation',
    SETTLED = 'settled',
    INACTIVE = 'inactive',
}

export enum AssetSubStatus {
    REPORTING_DELAY = 'reporting_delay',
    PAYMENT_OUTSTANDING = 'payment_outstanding',
    REPAID = 'repaid',
    EARLY_REPAYMENT = 'early_repayment',
}

export enum AssetClass {
    SHARE = 'share',
    PARTICIPATION_CERT = 'participation_cert',
    COOPERATIVE_SHARE = 'cooperative_share',
    PROFIT_PARTICIPATION = 'profit_participation',
    PROFIT_PARTICIPATION_SPV = 'profit_participation_spv',
    BOND = 'bond',
    CONVERTIBLE_BOND = 'convertible_bond',
    SUBORDINATED_LOAN = 'subordinated_loan',
}

export enum AssetRegulation {
    ECSP = 'ecsp',
    VERMANLG = 'vermanlg',
    FINMA = 'finma',
    STANDORTFOEG = 'standortfoeg',
}

export enum AssetJurisdiction {
    AT = 'AT',
    DE = 'DE',
    CH = 'CH',
    EU = 'EU',
}

export enum StockType {
    REGISTERED_SHARES = 'registered_shares',
    BEARER_SHARES = 'bearer_shares',
    COMMON_SHARES = 'common_shares',
    PREFERRED_SHARES = 'preferred_shares',
}

export enum TransferRestriction {
    NONE = 'none',
    VINCULATION = 'vinculation',
    LOCKUP = 'lockup',
}

export enum SpvLegalForm {
    GMBH = 'gmbh',
    AG = 'ag',
    TRUST = 'trust',
}
